<nb-card>
  <nb-card-body>
    <div id="print-section" class="print-layout">
      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tr *ngIf="shop.coverUrl">
          <td style="text-align: center">
            <img width="80" [src]="shop.coverUrl" alt="" />
          </td>
        </tr>
        <tr>
          <td class="height-1"></td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              {{ shop.address }}
            </label>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              <span *ngIf="shop.mobile">{{ shop.mobile }}</span>
            </label>
          </td>
        </tr>

        <tr>
          <td class="height-1"></td>
        </tr>

        <!-- <tr>
          <td style="text-align: center">
            <h4>NON TAX INVOICE</h4>
          </td>
        </tr> -->
        <tr>
          <td style="text-align: center">
            <label>
              Date:
              {{ receipt.issueDate | date : "dd/MM/yyyy " }}
            </label>
          </td>
        </tr>
        <tr *ngIf="receipt.id.length > 6">
          <td style="text-align: center">
            <label>
              Code:
              {{ receipt.id.substring(receipt.id.length - 6, 6) }}
            </label>
          </td>
        </tr>

        <tr>
          <td class="height-1"></td>
        </tr>

        <tr *ngIf="receipt.customerName">
          <td style="text-align: left">
            <label> {{ receipt.customerName }} </label>
          </td>
        </tr>
        <tr *ngIf="receipt.customerMobile">
          <td style="text-align: left">
            <label> {{ receipt.customerMobile }} </label>
          </td>
        </tr>
        <tr *ngIf="receipt.customerAddress">
          <td style="text-align: left">
            {{ receipt.customerAddress }}
          </td>
        </tr>

        <tr>
          <td style="text-align: center">
            <table
              width="100%"
              style="border: 0px"
              cellpadding="0"
              cellspacing="0"
            ></table>
          </td>
        </tr>

        <tr>
          <td><hr /></td>
        </tr>
      </table>

      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tbody>
          <tr *ngFor="let item of receipt.receiptDetails; let i = index">
            <td colspan="2" style="text-align: left">
              <table
                width="100%"
                cellpadding="0"
                cellspacing="0"
                class="table-detail-pos"
              >
                <tr>
                  <td colspan="3" style="text-align: left">
                    <label *ngIf="!isRefLanguage">
                      {{ item.productName }}
                    </label>
                    <label *ngIf="isRefLanguage">
                      {{
                        item.productDescription
                          ? item.productDescription
                          : item.productName
                      }}
                    </label>
                  </td>
                </tr>
                <tr>
                  <td>
                    {{ item.price | number : "1.2-2" }}
                  </td>
                  <td>x{{ item.quantity | number : 0 }}</td>
                  <td style="text-align: right">
                    {{ item.netAmount | number : "1.2-2" }}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td colspan="2"><hr /></td>
          </tr>
        </tbody>

        <tfoot>
          <tr>
            <td style="text-align: left">
              <label> Sub Total: </label>
            </td>
            <td style="text-align: right">
              {{ receipt.detailNetAmount | number : "1.2-2" }}
            </td>
          </tr>
          <tr>
            <td style="text-align: left">
              <label>
                Discount:<span *ngIf="receipt.discountPercent > 0">
                  {{ receipt.discountPercent | number : 0 }}%
                </span>
              </label>
            </td>
            <td style="text-align: right">
              {{ receipt.totalDiscountAmount | number : "1.2-2" }}
            </td>
          </tr>
          <tr *ngIf="receipt.vatAmount > 0">
            <td style="text-align: left">
              <label>
                VAT:<span> {{ receipt.vatPercent | number : 0 }}% </span>
              </label>
            </td>
            <td style="text-align: right">
              {{ receipt.vatAmount | number : "1.2-2" }}
            </td>
          </tr>
          <tr>
            <td style="text-align: left">
              <label> Grand Total: </label>
            </td>
            <td style="text-align: right">
              {{ receipt.totalAmount | number : "1.2-2" }}
            </td>
          </tr>
          <!-- <tr *ngIf="receipt.paymentRefund > 0">
            <td style="text-align: left"><label> Paid: </label></td>
            <td style="text-align: right">
              {{ receipt.paymentAmount | number: "1.2-2" }}
            </td>
          </tr>
          <tr *ngIf="receipt.paymentRefund > 0">
            <td style="text-align: left"><label>Refund: </label></td>
            <td style="text-align: right">
              {{ receipt.paymentRefund | number: "1.2-2" }}
            </td>
          </tr> -->
        </tfoot>
      </table>

      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tr>
          <td class="height-1"></td>
        </tr>
        <tr>
          <td colspan="2" style="text-align: center">Scan here to pay</td>
        </tr>

        <tr>
          <td style="text-align: left">ABA Pay USD</td>
          <td style="text-align: right">ABA Pay RIEL</td>
        </tr>
        <tr>
          <td style="text-align: left">
            <img width="100" src="/assets/images/qr-usd.png" alt="" />
          </td>
          <td style="text-align: right">
            <img width="100" src="/assets/images/qr-riel.png" alt="" />
          </td>
        </tr>
        <tr>
          <td colspan="2" style="text-align: center">Thank You!</td>
        </tr>
      </table>
    </div>
  </nb-card-body>
</nb-card>
